// Footer.jsx
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaInstagram,FaWhatsapp ,FaFacebookF } from 'react-icons/fa';
const socials = [
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/brolax.electric1/',
    icon: <FaInstagram className="w-4 h-4" />
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/profile.php?id=61558773750737',
    icon: <FaFacebookF className="w-4 h-4" />
  },
  {
    name: 'WhatsApp',
    url: 'https://wa.me/+972595042586',
    icon: <FaWhatsapp className="w-4 h-4" />
  },
  
];
export default function Footer() {
  const linkHover = {
    rest: { x: 0 },
    hover: { x: -4, transition: { duration: 0.2 } }
  };

  return (
    <footer className="bg-black text-white border-t border-white/10 relative overflow-hidden">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#CC0000]/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-3 mb-6 group w-fit">
              <span className="text-2xl font-black tracking-widest text-white group-hover:text-[#CC0000] transition-colors duration-300">BROLAX</span>
              <span className="bg-[#CC0000] text-white px-2 py-0.5 rounded text-xs font-black tracking-wider">BX</span>
            </Link>
            <p className="text-neutral-400 text-sm leading-relaxed max-w-sm mb-8">
              أجهزة كهربائية منزلية احترافية. هندسة ألمانية. صُممت لتدوم وتمنحك تجربة طهي استثنائية.
            </p>
            <div className="flex gap-4">
              {socials.map((social) => (
                <motion.a 
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.1, backgroundColor: '#CC0000' }}
                  className="w-10 h-10 rounded-full bg-neutral-900 border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-white transition-colors"
                >
                  <span className="sr-only">{social.name}</span>
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Shop */}
          <div className="md:col-span-2 md:col-start-6">
            <h4 className="text-[#CC0000] font-bold text-sm mb-6 tracking-wider uppercase">تسوق</h4>
            <ul className="space-x-4">
              {['جميع المنتجات'].map((item, i) => (
                <motion.li key={i} variants={linkHover} initial="rest" whileHover="hover">
                  <Link to="/shop" className="text-neutral-400 hover:text-white text-sm transition-colors ">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#CC0000] opacity-0 group-hover:opacity-100 transition-opacity" />
                    {item}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div className="md:col-span-2">
            <h4 className="text-[#CC0000] font-bold text-sm mb-6 tracking-wider uppercase">خدمة العملاء</h4>
            <ul className="space-y-4">
              {[
                { to: '/track', label: 'تتبع الطلب' },
                { to: '/contact', label: 'اتصل بنا' },
                { to: '/faq', label: 'الأسئلة الشائعة' },
                { to: '/warranty', label: 'الضمان' }
              ].map((item, i) => (
                <motion.li key={i} variants={linkHover} initial="rest" whileHover="hover">
                  <Link to={item.to} className="text-neutral-400 hover:text-white text-sm transition-colors">
                    {item.label}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-3">
            <h4 className="text-[#CC0000] font-bold text-sm mb-6 tracking-wider uppercase">الشركة</h4>
            <ul className="space-y-4">
              {[
                { to: '/about', label: 'عن برولاكس' },
                { to: '/privacy', label: 'سياسة الخصوصية' },
                { to: '/terms', label: 'شروط الخدمة' }
              ].map((item, i) => (
                <motion.li key={i} variants={linkHover} initial="rest" whileHover="hover">
                  <Link to={item.to} className="text-neutral-400 hover:text-white text-sm transition-colors">
                    {item.label}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            © {new Date().getFullYear()} برولاكس. جميع الحقوق محفوظة.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-neutral-600 text-xs">مدعوم بواسطة</span>
            <span className="text-neutral-400 font-bold text-sm tracking-wider">BROLAX ELECTRIC</span>
          </div>
        </div>
      </div>
    </footer>
  );
}